import { Component, ViewChild, ElementRef, AfterViewInit , OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ApiService } from '../../api/api.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  title = 'angular-image-file-upload-tutorial';

  @ViewChild('UploadFileInput', { static: false }) uploadFileInput!: ElementRef;
  @ViewChild('uploadFileResInput', { static: true, read: ElementRef }) uploadFileResInput!: ElementRef;

  fileUploadForm: any;
  fileInputLabel: any;
  fileArray: any;

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private api: ApiService
  ) { }

  ngOnInit(): void {
    this.fileUploadForm = this.formBuilder.group({
      uploadedImage: [''],
      uploadedText: [''],
      uploadedText1: [''],
      uploadedPdf: ['']
    });
  }


  onFileSelect(event:any) {
    const file = event.target.files[0];
    // this.fileInputLabel = file.name;
    console.log(file.size);
    console.log(file)

    if(50000 < file.size){
      alert("Upload Only 50kb");
      this.uploadFileInput.nativeElement.value = "";
    }
    // this.fileArray = file;
    this.fileUploadForm.get('uploadedImage').setValue(file);
  }

  onFileSelectRes(event:any) {
    const file = event.target.files[0];

    // this.fileInputLabel = file.name;
    console.log(file);
    if(50000 < file.size){
      alert("Upload Only 50kb");
      this.uploadFileResInput.nativeElement.value = "";
    }
    // this.fileArray = file;
    this.fileUploadForm.get('uploadedPdf').setValue(file);
  }

public rollno:any;
public text1:any;
public text2:any;
public uplImg:any;
public uplRes:any;

  onFormSubmit() {

    console.log(this.fileUploadForm.get('uploadedImage').value);
    if (!this.fileUploadForm.get('uploadedImage').value && !this.fileUploadForm.get('uploadedPdf').value) {
      alert('Please fill valid details!');
      return;
    }

      // this.api.uploadFile(this.fileArray,this.fileUploadForm.value.uploadedText,this.fileUploadForm.value.uploadedText1).pipe(first()).subscribe((res:any)=>{
      //   console.log(res)
      // })




    const formData = new FormData();
    formData.append('uploadedImage', this.fileUploadForm.get('uploadedImage').value);
    formData.append('uploadedPdf', this.fileUploadForm.get('uploadedPdf').value);
    formData.append('fileUploadForm', JSON.stringify(this.fileUploadForm.value));

    var myargs = formData;
    var myargsText = this.fileUploadForm.value;
    console.log(myargs)


    this.api.uploadTest(myargs).subscribe((result:any)=>{
      console.log(result[0]['refno']);

      this.rollno = result[0]['refno'];
      this.text1 = result[0]['text1'];
      this.text2 = result[0]['text2'];
      this.uplImg = result[0]['img'];
      this.uplRes = result[0]['pdf'];


      if (result.statusCode === 200) {
        // Reset the file input
        this.uploadFileInput.nativeElement.value = "";
        this.fileInputLabel = undefined;
      }
    }, er =>{
      console.log(er);
        alert(er.error.error);
    });

    // this.http.post<any>('http://localhost:5001/uploadfile', formData).subscribe(response => {
    //     console.log(response);
    //     if (response.statusCode === 200) {
    //       // Reset the file input
    //       this.uploadFileInput.nativeElement.value = "";
    //       this.fileInputLabel = undefined;
    //     }
    //   }, er => {
    //     console.log(er);
    //     alert(er.error.error);
    //   });
  }



}
